// Import components and modules to bootstrap the app
import AppComponent from './components/app/app.component';
import './../../dist/app/templates/templates';
import './services/index';
import './directives/index';
import './components/daisy/index';
import './components/login/index';
import './components/logout/index';
import './components/timeselector/index';
import HttpInterceptor from './services/HttpInterceptor.service';

// Config
import config from './components/app/app.config';
// Run
import run from './components/app/app.run';

// Base Modul
angular
	.module('app', [
		'ngComponentRouter',
		'ngAnimate',
		'ngMaterial',
		'ngMessages',
		'ngStorage',
		'angularMoment',
		'md.data.table',
		'md.time.picker',
		'templates',
		'app.services',
		'app.directives',
		'app.daisy',
		'app.login',
		'app.logout',
		'app.timeselector'
	])
	.config(config)
	.value('$routerRootComponent', 'app')
	.factory('HttpInterceptor', HttpInterceptor)
	.component('app', AppComponent)
	.run(run);

/*
 * Fetch config data and assign to constant
 */
fetchData().then(bootstrapApplication);

/*
 * Fetch config data and assign to angular constant
 */
function fetchData() {
	const injector = angular.injector(['ng']);
	const $http = injector.get('$http');

	return $http.get('data/generated/config.json')
		.then((response) => {
			response.data.timestamp = new Date();
			angular.module('app').constant('app.config', response.data);
		}, (err) => {
			// ToDo: Implement fallback if loading fails.
			//console.log('failure during config load', err);
		}
	);

}

/*
 * Manually bootstrap AngularJS after the configuration file has been loaded
 */
function bootstrapApplication() {
	angular.element(document).ready( () => {
		angular.bootstrap(document, ['app']);
	});
}
